import { Component, OnInit, computed, effect, inject, input, output } from "@angular/core";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ReferenceMeasurementItemLengthComponent } from "@components/reference-measurement-item-length/reference-measurement-item-length.component";
import { FloorplanItem } from "@domain/project/floorplan/floorplan-item";
import { FloorplanSidesheetExtent } from "@domain/project/floorplan/floorplan-sidesheet-extent";
import { CableRoute } from "@domain/project/floorplan/wiring/cable-route";
import { DisabledController } from "@odx/angular";
import { CheckboxComponent } from "@odx/angular/components/checkbox";
import { FormDirective, FormFieldComponent, FormFieldControlDirective } from "@odx/angular/components/form-field";
import { TooltipDirective } from "@odx/angular/components/tooltip";
import { FloorplanItemDetailsComponent } from "@project/floorplanner/floorplan-additional-notes/floorplan-item-details/floorplan-item-details.component";

@Component({
  selector: "app-cable-route-notes",
  imports: [
    FloorplanItemDetailsComponent,
    FormDirective,
    FormFieldComponent,
    FormFieldControlDirective,
    FormsModule,
    ReactiveFormsModule,
    DisabledController,
    CheckboxComponent,
    ReferenceMeasurementItemLengthComponent,
    TooltipDirective,
  ],
  templateUrl: "./cable-route-notes.component.html",
  styleUrl: "./cable-route-notes.component.scss",
  standalone: true,
})
export class CableRouteNotesComponent implements OnInit {
  private readonly formBuilder = inject(FormBuilder);

  readonly floorplanItem = input.required<FloorplanItem>();
  readonly extent = input.required<FloorplanSidesheetExtent>();
  readonly toggleExtendedButtonClicked = output<void>();
  protected readonly cableRoute = computed(() => this.floorplanItem() as CableRoute);

  protected cableRouteForm?: FormGroup;
  protected readonly tooltipTextDeprecatedLength: string = $localize`:@@floorplan.length.deprecated:Dieses Feld ist veraltet und wird zeitnah entfernt`;

  constructor() {
    effect(() => {
      const cableRoute = this.cableRoute();
      this.cableRouteForm?.reset(
        {
          name: cableRoute.name,
          constructionKit: cableRoute.constructionKit,
          scalingLength: cableRoute.scalingLength,
        },
        { emitEvent: false },
      );
    });
  }

  ngOnInit() {
    this.initForm();
  }

  private update(): void {
    this.cableRoute().updateMetadata(
      this.cableRouteForm!.value.constructionKit,
      this.cableRouteForm!.value.scalingLength,
      this.cableRouteForm!.value.name,
    );
  }

  private initForm() {
    this.cableRouteForm = this.formBuilder.group({
      name: [this.cableRoute().name],
      constructionKit: [this.cableRoute().constructionKit],
      scalingLength: [this.cableRoute().scalingLength],
    });

    this.cableRouteForm.valueChanges.subscribe(() => {
      if (!this.cableRouteForm!.valid || this.cableRouteForm!.pristine) return;
      this.update();
    });
  }
}
